import type { ReactNode } from "react";
import type { Span } from "../api/client";

/** Renders text with highlighted terms. Span offsets come from Python, which counts code points,
 *  so we index by code point too (an emoji would otherwise shift every later highlight). */
export function RichText({
  text,
  spans,
  onTerm,
}: {
  text: string;
  spans: Span[];
  onTerm: (termId: string) => void;
}) {
  const chars = Array.from(text);
  const out: ReactNode[] = [];
  let last = 0;
  for (const s of [...spans].sort((a, b) => a.start - b.start)) {
    if (s.start < last) continue;
    out.push(chars.slice(last, s.start).join(""));
    out.push(
      <button
        key={`${s.start}-${s.term_id}`}
        type="button"
        className="term"
        onClick={(e) => {
          e.stopPropagation();
          onTerm(s.term_id);
        }}
      >
        {chars.slice(s.start, s.end).join("")}
      </button>,
    );
    last = s.end;
  }
  out.push(chars.slice(last).join(""));
  return <>{out}</>;
}
